import { useMutation } from '@tanstack/react-query';
import { PaymentService } from 'src/services/api';
import { postRequest } from 'src/services/api/http';
import { URL_ENDPOINT } from 'src/utils/constants/service';
import { IBillingDetailPayload, ICheckoutSessionPayload } from 'src/utils/typings/dto/payment';

export const useMutateUpdateCustomerInfo = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (body: IBillingDetailPayload) => PaymentService.updateCustomerInformation(body),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateGetCheckoutSession = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (body: ICheckoutSessionPayload) => PaymentService.getCheckoutSession(body),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateCancelSubscription = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (subscriptionId: string) => PaymentService.cancelSubscription(subscriptionId),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateCheckEntityPaid = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: ({ entityId, type }: { entityId: string; type: string }) =>
      PaymentService.checkEntityPaid({ entityId, type }),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateCalculatePricePlan = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: ({ priceId }: { priceId: string }) => PaymentService.calculatePricePlan({ priceId }),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateChangePlan = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: ({ priceId }: { priceId: string }) => PaymentService.changePlan({ priceId }),
  });
  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateSubscriptionFreeTrial = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: ({
      planId,
      affiliateCode,
      campaignSlug,
    }: {
      planId: number;
      affiliateCode?: string;
      campaignSlug?: string;
    }) => PaymentService.subscriptionFreeTrial({ planId, affiliateCode, campaignSlug }),
  });
  return {
    isPending,
    mutateAsync,
  };
};


export const useMutationDeleteTeamMember = () => {
  return useMutation({
    mutationFn: (dto: Record<string, string | number>) => postRequest(URL_ENDPOINT.payment.team.deleteMember, dto),
  });
}

export const useAddTeamMember = () => {
  return useMutation({
    mutationFn: (dto: Record<string, string | number>) => postRequest(URL_ENDPOINT.payment.team.addMember, dto),
  });
}

export const useMutationLeaveTeam = () => {
  return useMutation({
    mutationFn: (dto: Record<string, string | number>) => postRequest(URL_ENDPOINT.payment.team.leaveGroup, dto),
  });
}
